import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { AlertController, LoadingController } from '@ionic/angular';
import { Router } from '@angular/router';
import { CatalogService } from 'src/app/services/catalog.service';

@Component({
  selector: 'app-matrix',
  templateUrl: './matrix.component.html',
  styleUrls: ['./matrix.component.scss'],
})
export class MatrixComponent implements OnInit {

  @Input() type: string;
  @Input() value: string;
  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>(false);

  // Internal state
  loggedUser: any;
  catalogItems: any;
  improvedCatalogItems = {};

  constructor(
    private userService: UserService,
    private catalogService: CatalogService,
    private alertController: AlertController,
    private loadingController: LoadingController,
    private router: Router
  ) { }

  async ngOnInit() {
    this.catalogItems = await this.catalogService.getCatalogItems();

    this.loggedUser = await this.userService.getLoggedUser();
    this.userService.loggedUserObservable.subscribe((updatedUser) => {
      if (!!updatedUser) {
        this.loggedUser = updatedUser;
        this.setImprovedCatalogItems();
      }
    });

    this.setImprovedCatalogItems();
  }

  setImprovedCatalogItems() {
    if (!!this.loggedUser === false) { return false; }
    const isUserPro = this.userService.isUserPro();
    for (const key of Object.keys(this.catalogItems)) {
      this.improvedCatalogItems[key] = null;
      this.improvedCatalogItems[key] = this.catalogItems[key].map((item) => {
        const isPurchased = ( isUserPro || (this.loggedUser.purchases.findIndex(p => p.catalog_item_id === item.id) !== -1) );
        return { ...item, isPurchased };
      });
    }
  }

  async select(matrix: string) {
    const isMatrixEnabled = await this.handlePurchase(matrix);
    if (isMatrixEnabled === false) { return; }
    this.value = matrix;
    this.valueChange.emit(matrix);
  }

  async handlePurchase(matrix) {
    const catalogItem = this.catalogItems[this.type].find(item => item.item_detail === matrix);
    if (!!catalogItem === false) {
      return true;
    }

    // Check if user is guest. Guest canno buy elements
    const isUserGuest = this.userService.isUserGuest();
    if (isUserGuest) {
      await this.showYouAreGuestMessage();
      return false;
    }

    // Chek if use have already buyed element
    const isPurchased = this.isMatrixPurchased(matrix, this.type);
    if (!!isPurchased) {
      return true;
    }

    // Check if user has already needed credits
    if (this.loggedUser.points < catalogItem.points_required) {
      await this.showNoCreditsMessage();
      return false;
    }

    // User has enough credits let he decide if buy something
    const userChoice = await this.askForPurchase(catalogItem.points_required);
    if (!!userChoice === false) {
      return false;
    }

    // Proceed with purchase
    const buyResult = await this.buyItem(matrix);
    if (!!buyResult) { }

    return false; // Return false also with a successful purchase, to permit to the user to buy other matrixes
  }

  isMatrixPurchased(matrix, type) {
    const catalogItem = this.improvedCatalogItems[type].find(item => item.item_detail === matrix);
    if (!!catalogItem) {
      return catalogItem.isPurchased;
    }
    return true;
  }

  async askForPurchase(creditsCost) {
    return new Promise<boolean>(async (resolve, reject) => {
      const alert = await this.alertController.create({
        cssClass: '',
        header: 'Catalogo',
        message: `Vuoi sbloccare questo ballottaggio? (${creditsCost} crediti)`,
        buttons: [{
          text: 'Sì',
          role: 'confirm',
          handler: () => { resolve(true); }
        },
        {
          text: 'No',
          role: 'cancel',
          handler: () => { resolve(false); }
        }]
      });
      await alert.present();
    });
  }

  async showNoCreditsMessage() {
    const alert = await this.alertController.create({
      header: 'Non hai abbastanza crediti!',
      message: `Continua a votare i ballottaggi per accumulare i crediti necessari!`,
      buttons: [{
        text: 'OK!',
        handler: async () => {
          await this.router.navigate(['/home']);
        }
      }]
    });
    await alert.present();
  }

  async showYouAreGuestMessage() {
    const alert = await this.alertController.create({
      header: 'Iscrizione necessaria!',
      message: `Se vuoi sbloccare i ballottaggi, ISCRIVITI!`,
      buttons: [{
        text: 'Registrati',
        handler: async () => {
          await this.router.navigate(['/register']);
        }
      },
      {
        text: 'Più tardi',
        handler: async () => { }
      }]
    });
    await alert.present();
  }

  async buyItem(matrix) {
    const loading = await this.loadingController.create({ message: 'Acquisto in corso...' });
    await loading.present();

    // Get item data
    const selectedItem = this.catalogItems[this.type].find(item => item.item_detail === matrix);
    if (!!selectedItem === false) {
      return false;
    }

    // Proceed with item purchase
    const buyResult = await this.catalogService.buyCatalogItem(selectedItem.id, this.loggedUser.id, 'points');
    if (!!buyResult) {
      await this.userService.setLoggedUser(buyResult.user);
      const typeString = this.getBallotTypeString(selectedItem.item_type);
      const confirmAlert = await this.alertController.create({
        header: 'Complimenti!',
        message: `Hai sbloccato un ballottaggio di ${typeString} ${selectedItem.item_description}!
                    Inseriscilo e attendi le risposte degli utenti!`,
        buttons: [{
          text: 'Ok',
          role: 'confirm',
          handler: () => { }
        }]
      });
      await loading.dismiss();
      return await confirmAlert.present();
    }

    await loading.dismiss();
  }

  getBallotTypeString(itemType) {
    let ballotTypeString = '';
    switch (itemType) {
      case 'exchange':
        ballotTypeString = 'Scambio';
        break;
      case 'formation':
        ballotTypeString = 'Formazione';
        break;
      case 'purchase':
        ballotTypeString = 'Acquisto';
        break;
    }
    return ballotTypeString;
  }

}
